import { Page } from "../../layout/page";
import { Accordion, Title, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import ConsultantReportOrder from "../../components/consultantReport/consultantReportOrder";
import ConsultantReportService from "../../components/consultantReport/consultantReportService";
import ConsultantReportOrderRenewal from "../../components/consultantReport/consultantReportOrderRenewal";
import ConsultantReportPendingCase from "../../components/consultantReport/consultantReportPendingCase";
import ConsultantReportDebitNote from "../../components/consultantReport/consultantReportDebitNote";
import ConsultantReportGIRenewal from "../../components/consultantReport/consultantReportGIRenewal";
import ConsultantReportClient from "../../components/consultantReport/consultantReportClient";

const ConsultantReport = () => {
  const { t } = useTranslation();

  const reports = [
    {
      title: t("Order Report"),
      reportComponent: ConsultantReportOrder,
    },
    {
      title: t("Order Service Report"),
      reportComponent: ConsultantReportService,
    },
    {
      title: t("Order Renewal Report"),
      reportComponent: ConsultantReportOrderRenewal,
    },
    {
      title: t("Order Pending Case Report"),
      reportComponent: ConsultantReportPendingCase,
    },
    {
      title: t("GI Debit Note Report"),
      reportComponent: ConsultantReportDebitNote,
    },
    {
      title: t("GI Renewal Report"),
      reportComponent: ConsultantReportGIRenewal,
    },
    {
      title: "Client Report",
      reportComponent: ConsultantReportClient,
    },
  ];

  return (
    <Page title={t("Report")}>
      <Text size="sm" color="dimmed" mt="md">
        {t(
          "Reports include only records where you are assigned as a consultant."
        )}
      </Text>
      <Accordion variant="separated" radius="xs" mt="md">
        {reports.map((r) => (
          <Accordion.Item key={r.title} value={r.title}>
            <Accordion.Control>
              <Title order={5}>{r.title}</Title>
            </Accordion.Control>
            <Accordion.Panel>
              <r.reportComponent />
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Page>
  );
};

export default ConsultantReport;
